import { Configuration, LogLevel } from '@azure/msal-browser'
import { env } from '../../utilities'
export const msalConfig: Configuration = {
  auth: {
    clientId: env.aadClientId,
    authority: `${env.aadInstance}/${env.aadDomain}/${env.aadUserFlowLogin}`,
    knownAuthorities: [env.aadInstance],
    redirectUri: new URL(
      `${env.basePath.replace(/\/+$/, '')}/authorize`,
      `${window.location.protocol}//${window.location.host}`,
    ).href,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
        }
      },
    },
  },
}
